import { Repeat } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@krea/shared/design-system/Button";
import { ResponsiveTooltip } from "@krea/shared/design-system/ResponsiveTooltip";

/** Ghost restart button with a tooltip — resets the widget to run another estimate. */
export const MakeAnotherEstimateButton = ({
  onClick,
  portalContainer,
}: {
  onClick: () => void;
  portalContainer?: HTMLElement | null;
}) => {
  const { t } = useTranslation("loanWidget");

  return (
    <ResponsiveTooltip
      trigger={
        <Button
          variant="ghost"
          size="icon"
          onClick={onClick}
          aria-label={t("loanWidget.makeAnotherEstimate")}
        >
          <Repeat className="h-4 w-4" aria-hidden="true" />
        </Button>
      }
      side="left"
      align="center"
      portalContainer={portalContainer}
    >
      {t("loanWidget.makeAnotherEstimate")}
    </ResponsiveTooltip>
  );
};
